import React from "react";

export type OnAfterCreateCustomerFn = (
  customerId: string
) => Promise<boolean | void> | boolean | void;

export type OnCustomerSelectedFn = (
  customerId: string
) => Promise<boolean | void> | boolean | void;

export type CustomerRootScreenActionsContextType = {
  onCustomerSelected?: OnCustomerSelectedFn;
  onAfterCreateCustomer?: OnAfterCreateCustomerFn;
  customerListScreenTitle?: string;
  hideNewCustomerButton?: boolean;
  retailerCustAccountOnly?: boolean;
};

export const CustomerRootScreenActionsContext = React.createContext<
  CustomerRootScreenActionsContextType | undefined
>(undefined);
